/**
 * Stable CSS class names for E2E — TransferCargoData page.
 */
export const TCD = {
    page: 'transfer-cargo-data-page',
    breadcrumbSection: 'transfer-cargo-data-page__breadcrumb-section',
    loadingWrap: 'transfer-cargo-data-page__loading-wrap',
    actionsRow: 'transfer-cargo-data-page__actions-row',
    singleSearchWrap: 'transfer-cargo-data-page__single-search-wrap',
    singleSearchPaper: 'transfer-cargo-data-input--single-search-paper',
    singleSearchInput: 'transfer-cargo-data-input--single-search-input',
    singleSearchButton: 'transfer-cargo-data-input--button-single-search',
    batchModuleWrap: 'transfer-cargo-data-page__batch-search-wrap',
    dataGridWrap: 'transfer-cargo-data-page__data-grid-wrap',
    noRecordWrap: 'transfer-cargo-data-page__no-record-wrap',
    cellShippingWrap: 'transfer-cargo-data__cell-shipping-wrap',
    cellMessageWrap: 'transfer-cargo-data__cell-message-wrap',
} as const;

export const tcdCls = (...parts: Array<string | undefined | false>) => parts.filter(Boolean).join(' ');
